<ng-container [formGroup]="formGroup">
  <ng-container [formGroupName]="blockFormName">
    <div fxLayout="column">
      <app-form-render-label [item]="item"></app-form-render-label>
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <input
          [formControlName]="item.key"
          [matDatepicker]="picker"
          [matDatepickerFilter]="dateFilter"
          [matTooltip]="item.options_obj.tooltip"
          [placeholder]="item.options_obj.label"
          [required]="item.options_obj.isRequired"
          matInput>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
          <mat-error>
            {{getErrorMessage(item.block, item.key)}}
          </mat-error>
        </div>
      </mat-form-field>
    </div>
  </ng-container>
</ng-container>
